export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <h3 className="font-heading text-lg font-bold text-white mb-3">探花系列</h3>
              <p className="text-sm leading-relaxed text-foreground-400">
                探花官网入口与探花最新地址发布页，专注提供探花在线免费资源与探花精选合集，是您安全访问探花内容的首选导航平台。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-3">快速导航</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="#carousel" onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">焦点专题</a></li>
                <li><a href="#updates" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a></li>
                <li><a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门排行</a></li>
                <li><a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问答</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-3">资源导航</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">主题索引</a></li>
                <li><a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a></li>
                <li><a href="#app" onClick={(e) => { e.preventDefault(); document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">移动入口</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-3">合作伙伴</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                感谢各位合作伙伴的长期支持，具体合作信息请通过联系方式与我们取得联系。
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              探花系列 &copy; {new Date().getFullYear()} 版权所有 | 探花官网入口发布页
            </p>
            <p className="text-xs text-foreground-600">
              探花 · 探花最新地址 · 探花在线 · 探花精选
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}